var __webpack_error__ = new Error();
module.exports = new Promise(function(resolve, reject) {
	if(typeof users_management_app !== "undefined") return resolve();
	__webpack_require__.l("https://nw-user-mgt-app.newwealth.cloud/remoteEntry.js", function(event) {
		if(typeof users_management_app !== "undefined") return resolve();
		var errorType = event && (event.type === 'load' ? 'missing' : event.type);
		var realSrc = event && event.target && event.target.src;
		__webpack_error__.message = 'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
		__webpack_error__.name = 'ScriptExternalLoadError';
		__webpack_error__.type = errorType;
		__webpack_error__.request = realSrc;
		reject(__webpack_error__);
	}, "users_management_app");
}).then(function() { return users_management_app; });